import { z } from "zod";

export const updateAiControlEmail = z.object({
  email: z.string().email("Veuillez entrer un email valide"),
});

export type UpdateAiControlEmailForm = z.infer<typeof updateAiControlEmail>;
